<div class="iguau-profile-edit bg-white rounded-4 mb-3 p-3 div-shadow">
  <div class="row mb-2">
    <div class="col-4 col-sm-4 col-md-3 col-lg-2">
      <img [src]="previewUrl ? previewUrl : perfil?.foto?.foto_principal_thumb" class="rounded-circle pointer" width="100%" alt="Foto de perfil"
            (click)="onClickImagenPrincipal()">
    </div>
    <div class="col">
      <!--PERFIL SOCIAL-->
      <div class="row" *ngIf="perfil.rol_perfil == 'social'">
        <div class="col-12 col-lg-auto mb-1">
          <label for="first_name" class="form-label">Nombre</label>
          <input type="text" id="first_name" class="form-control" [(ngModel)]="perfil.first_name">
        </div>
        <div class="col-auto mb-1">
          <label for="sexo" class="form-label">Sexo</label>
          <select id="sexo" class="form-select" [(ngModel)]="perfil.sexo">
            <option value="Hombre">Hombre</option>
            <option value="Mujer">Mujer</option>
            <option value="Otro">Otro</option>
            <option value="Prefiero no decirlo">Prefiero no decirlo</option>
          </select>
        </div>
        <div class="col-auto mb-1">
          <label for="fecha_nac" class="form-label">Fecha nacimiento</label>
          <input type="date" id="fecha_nac" class="form-control" [(ngModel)]="perfil.fecha_nac">
          <div class="mini text-secondary">
            <i class="fa-solid fa-circle-info"></i> Solo para calcular edad
          </div>
        </div>
      </div>
      <!--PERFIL PROFESIONAL-->
      <div class="row" *ngIf="perfil.rol_perfil == 'profesional'">
        <div class="col-12 col-lg-auto mb-1">
          <label for="first_name" class="form-label">Nombre comercial o profesional</label>
          <div class="small text-secondary">ej. "Peluquería Canina Guau", "Carlos - Adiestrador"</div>
          <input type="text" id="first_name" class="form-control" [(ngModel)]="perfil.first_name">
        </div>
        <div class="col-12 col-lg-auto mb-1">
          <label for="slogan" class="form-label">Eslogan o frase corta</label>
          <div class="small text-secondary">Una línea que defina su propuesta de valor (ej. "Veterinaria 24h especializada en gatos").</div>
          <input type="text" id="slogan" class="form-control" [(ngModel)]="perfil.slogan">
        </div>
        <div class="col-12 col-lg-auto mb-1">
          <label for="categoria" class="form-label">Categoría</label>
          <div class="small text-secondary">Peluquería, Veterinaria, Guardería, Paseador, Adiestrador,...</div>
          <input type="text" id="categoria" class="form-control" [(ngModel)]="perfil.categoria">
        </div>
        <div class="col-12 col-lg-auto mb-1">
          <label for="ofrece_domicilio" class="form-label">¿Ofreces servicio a domicilio?</label>
          <div class="small text-secondary">Si/No</div>
          <select id="ofrece_domicilio" class="form-select" [(ngModel)]="perfil.ofrece_domicilio">
            <option [value]="true">Sí</option>
            <option [value]="false">No</option>
          </select>
        </div>
        <div class="col-12 col-lg-auto mb-1">
          <label for="telefono1" class="form-label">Teléfono</label>
          <div class="small text-secondary">Ej. "123 456 789"</div>
          <input type="text" id="telefono1" class="form-control" [(ngModel)]="perfil.telefono1">
        </div>
        <div class="col-12 col-lg-auto mb-1">
          <label for="telefono2" class="form-label">Teléfono</label>
          <div class="small text-secondary">Ej. "123 456 789"</div>
          <input type="text" id="telefono2" class="form-control" [(ngModel)]="perfil.telefono2">
        </div>
        <div class="col-12 col-lg-auto mb-1">
          <label for="email" class="form-label">Correo electrónico</label>
          <div class="small text-secondary">Ej. "info&#64;ejemplo.com"</div>
          <input type="email" id="email" class="form-control" [(ngModel)]="perfil.email">
        </div>
        <div class="col-12 col-lg-auto mb-1">
          <label for="paginaweb" class="form-label">Página web</label>
          <div class="small text-secondary">Ej. "https://www.ejemplo.com"</div>
          <input type="text" id="paginaweb" class="form-control" [(ngModel)]="perfil.paginaweb">
        </div>
        <div class="col-12 col-lg-auto mb-1">
          <label for="redsocial" class="form-label">Red social</label>
          <div class="small text-secondary">Ej. "https://www.instagram.com/ejemplo"</div>
          <input type="text" id="redsocial" class="form-control" [(ngModel)]="perfil.redsocial">
        </div>
        <div class="col-12 mb-1">
          <label for="direccionfisica" class="form-label">Dirección física</label>
          <div class="small text-secondary">Si tienes local, ej. "Calle 123, Ciudad"</div>
          <div class="buscador-container">
            <input 
              type="text" 
              [formControl]="inputBuscador" 
              [(ngModel)]="perfil.direccionfisica"
              id="direccionfisica"
              placeholder="Escribe una dirección (Ej: Calle Mayor, Madrid)..."
              (focus)="mostrarDesplegable = true"
            />
            <ul class="desplegable" *ngIf="mostrarDesplegable && (sugerencias$ | async) as sugerencias">
              <li *ngFor="let item of sugerencias" (click)="seleccionarDireccion(item)">
                {{ item.display_name }}
              </li>
              <li *ngIf="sugerencias.length === 0 && inputBuscador.value!.length > 3" class="sin-resultados">
                No se encontraron resultados
              </li>
            </ul>
          </div>
        </div>
        <div class="col-12 mb-1">
          <label for="descripcion" class="form-label">Descripción / Sobre nosotros</label>
          <div class="small text-secondary">Cuéntales a los usuarios sobre tu negocio, tus valores, tu historia... Haz que quieran conocerte y confiar en ti.</div>
          <textarea autoResize [maxLines]="5" [maxChars]="500" #perfilTextarea id="descripcion" class="form-control" rows="1" [(ngModel)]="perfil.description"></textarea>
        </div>
      </div>
      <div class="row mt-2 d-none d-md-block" *ngIf="perfil.rol_perfil == 'social'">
        <div class="col-auto">
          <div class="custom-link"> <!--(click)="app.permisoGeolocalizacion(false)"-->
            <i class="fa-solid fa-location-dot text-info"></i> <span *ngIf="!app.getgeo"><span *ngIf="perfil.barrio">{{perfil.barrio}}, </span>{{perfil.ciudad}}<span *ngIf="perfil.pais">, {{perfil.pais}}</span></span>
            <span class="spinner-grow spinner-grow-sm text-iguau" role="status" *ngIf="app.getgeo">
              <span class="visually-hidden">Loading...</span>
            </span>
            <span class="small text-secondary ms-1" *ngIf="app.getgeo">Obteniendo ubicación...</span>
          </div>
        </div>
        <div class="col-auto" [hidden]="app.getgeo">
          <div class="custom-link"><!-- (click)="app.permisoGeolocalizacion(false)"-->
            <i class="fa-solid fa-map-location-dot"></i> Actualizar
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row mt-2 d-xs-block d-md-none mb-3" *ngIf="perfil.rol_perfil == 'social'">
    <div class="col-auto">
      <div class="custom-link"> <!-- (click)="app.permisoGeolocalizacion(false)"-->
        <i class="fa-solid fa-location-dot text-info"></i> <span *ngIf="!app.getgeo"><span *ngIf="perfil.barrio">{{perfil.barrio}}, </span>{{perfil.ciudad}}<span *ngIf="perfil.pais">, {{perfil.pais}}</span></span>
        <span class="spinner-grow spinner-grow-sm text-iguau" role="status" *ngIf="app.getgeo">
          <span class="visually-hidden">Loading...</span>
        </span>
        <span class="small text-secondary ms-1" *ngIf="app.getgeo">Obteniendo ubicación...</span>
      </div>
    </div>
    <div class="col-auto" [hidden]="app.getgeo">
      <div class="custom-link"><!-- (click)="app.permisoGeolocalizacion(false)"-->
        <i class="fa-solid fa-map-location-dot"></i> Actualizar
      </div>
    </div>
  </div>
  <div class="mb-3" *ngIf="perfil.rol_perfil == 'social'">
    <label for="descripcion" class="form-label">Descríbete, cuenta algo de ti, presenta tu mundo animal, deja tu huella... <span class="small text-secondary">Opcional</span></label>
    <textarea autoResize [maxLines]="5" [maxChars]="500" #perfilTextarea id="descripcion" class="form-control" rows="1" [(ngModel)]="perfil.description"></textarea>
  </div>

  <div class="row">
    <div class="col"></div>
    <div class="col-auto text-end mb-3">
      <button class="btn btn-sm btn-secondary" title="Cancelar cambios" (click)="cancelar()">Cancelar</button>
    </div>
    <div class="col-auto text-end mb-3">
      <button class="btn btn-sm btn-primary" title="Guardar cambios" (click)="guardarPerfil(true)"><i class="fa-solid fa-floppy-disk"></i> Guardar</button>
    </div>
  </div>
</div>
<input
  type="file"
  #fileInputPrincipal
  accept="image/*"
  style="display: none"
  (change)="onFileSelectedPrincipal($event)"
/>
